export enum Sheet {
    Clean = 1,
    Normal = 2,
    Spotty = 3
}